import { useQuery } from '@tanstack/react-query';
import { GET_FLAG_REASONS, lawyerDirectoryService } from '@/api';

export const useFlagReasons = (caseId: string | undefined) => {
	const { data, isLoading, refetch } = useQuery({
		queryKey: [GET_FLAG_REASONS, caseId],
		queryFn: () => lawyerDirectoryService.getFlagReasons(caseId as string),
		enabled: !!caseId,
	});

	return {
		flagReasons: data?.data ?? [],
		isLoading,
		refetch,
	};
};
